'use client';

import { Container } from 'components/shared/Container';
import { ButtonV2 } from 'components/shared/ButtonV2';
import { H1, Subtitle } from './styleConstants';
import { CustomImage, useModal } from 'components/shared';
import { useEffect, useState } from 'react';
import { useTranslations } from 'next-intl';
import { PartnersTypeform } from './PartnersTypeform';
import styles from './HeroSection.module.css';

const imgHeroImage = 'web_v2/partners/uh-all-prod-banner.png/w_1920';
const imgHeroImageMobile = 'web_v2/partners/partners-hero-bg-resp.png';

export const HeroSection = ({
  className,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onExploreSolutions,
}: {
  className?: string;
  onExploreSolutions?: () => void;
}) => {
  const t = useTranslations('partners');
  const ModalClient = useModal();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 992px)');
    setIsMobile(mediaQuery.matches);

    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mediaQuery.addEventListener('change', handler);
    return () => mediaQuery.removeEventListener('change', handler);
  }, []);

  const handlePrimaryClick = () => {
    ModalClient.set(<PartnersTypeform />);
    ModalClient.setCloseButtonTheme('light');
    ModalClient.show();
  };

  return (
    <section className={`${styles.root}${className ? ` ${className}` : ''}`}>
      <Container className={styles.heroContent}>
        <div className={styles.heroTextContent}>
          <H1>{t('hero.title')}</H1>
          <Subtitle>{t('hero.subtitle')}</Subtitle>
          <div className={styles.ctaButtons}>
            <ButtonV2 variant="blue" onClick={handlePrimaryClick}>
              {t('hero.cta')}
            </ButtonV2>
            {/* <ButtonV2 variant="white" onClick={onExploreSolutions}>
              Explore solutions
            </ButtonV2> */}
          </div>
        </div>
      </Container>
      <div className={styles.heroImage}>
        <CustomImage
          src={isMobile ? imgHeroImageMobile : imgHeroImage}
          alt={t('hero.imageAlt')}
          width={1514}
          height={635}
          sizes="100vw"
        />
      </div>
    </section>
  );
};
